import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-confirmation-modal',
  template: `
<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ title }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ message }}</p>
    <div class="row mt-2" *ngIf="showRemark">
      <div class="col-12 col-md-2">
        <label for="remarks">Remarks: </label>
      </div>
      <div class="col-12 col-md-10">
        <textarea placeholder="Remarks" class="form-control" id="remarks" [(ngModel)]="remarks" name="collectionInfo"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger mr-2" (click)="onHide()">Cancel</button>
    <button type="button" class="btn btn-primary " (click)="onYes()">Confirm</button>
  </div>
</div>
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent implements OnInit {
  title: string;
  message: string;
  showRemark = true;

  public onClose: Subject<any>;
  public remarks = '';

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
    this.onClose = new Subject();
  }

  onYes() {
    this.onClose.next({ result: true, remarks: this.remarks });
    this.bsModalRef.hide();
  }

  onHide() {
    this.onClose.next({ result: false });
    this.bsModalRef.hide();
  }
}
